import type { SVGProps } from "react";

/**
 * image-sparkle, midjourney, ai generated, star
 * @category AI & Magic
 */
export default function IconImageSparkle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 5.75C3 4.23122 4.23122 3 5.75 3H18.25C19.7688 3 21 4.23122 21 5.75V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75ZM5.75 4.5C5.05964 4.5 4.5 5.05964 4.5 5.75V14.4393L6.05546 12.8839C7.1294 11.8099 8.8706 11.8099 9.94454 12.8839L16.5607 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V5.75C19.5 5.05964 18.9404 4.5 18.25 4.5H5.75ZM14.4393 19.5L8.88388 13.9445C8.39573 13.4564 7.60427 13.4564 7.11612 13.9445L4.5 16.5607V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H14.4393Z'
        fill='currentColor'
      />
      <path
        d='M13.4255 8.53727C13.4738 8.51308 13.5131 8.47385 13.5373 8.42546L14.2764 6.94721C14.3685 6.76295 14.6315 6.76295 14.7236 6.94721L15.4627 8.42546C15.4869 8.47385 15.5262 8.51308 15.5745 8.53727L17.0528 9.27639C17.237 9.36852 17.237 9.63148 17.0528 9.72361L15.5745 10.4627C15.5262 10.4869 15.4869 10.5262 15.4627 10.5745L14.7236 12.0528C14.6315 12.237 14.3685 12.237 14.2764 12.0528L13.5373 10.5745C13.5131 10.5262 13.4738 10.4869 13.4255 10.4627L11.9472 9.72361C11.763 9.63148 11.763 9.36852 11.9472 9.27639L13.4255 8.53727Z'
        fill='currentColor'
      />
    </svg>
  );
}
